// extracted by mini-css-extract-plugin
export var collapsedSummary = "_mj-0";